import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';

import ChipSelect from '@/components/fields/ChipSelect';
import Field from '@/components/fields/Field';
import TextInput from '@/components/fields/TextInput';
import { getNumberOfEmployeesOptions } from '@/containers/OrganizationSettings/basicOptions';
import { useIsMidotUser } from '@/hooks/permissions/useIsMidotUser';
import MidotUserDropdownSelect from '@/views/fields/UserDropdownSelect/MidotUserDropdownSelect';

const SubOrgMoreInfoTab: React.FC = () => {
  const { t } = useTranslation(['organizations', 'common']);
  const { isMidotUser } = useIsMidotUser();

  return (
    <Stack
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        p: 4,
        pt: 2,
        '& .MuiFormControl-root': {
          p: 0
        }
      }}
      gap={3}
    >
      <Field
        component={MidotUserDropdownSelect}
        name="keyAccountManagers"
        label={t('layouts.organizations.create.fields.keyAccountManagers')}
        markAsRequired
        innerProps={{
          isMulti: true,
          usePortal: true
        }}
        outerSx={{
          gridColumn: 'span 2'
        }}
        withFormControl
      />
      <Field
        component={ChipSelect}
        name="employeeCount"
        label={t('layouts.organizations.create.fields.numberOfEmployees')}
        markAsRequired
        innerProps={{
          options: getNumberOfEmployeesOptions(t),
          sx: { py: 0.25, mx: -0.5, '& .MuiButtonBase-root': { px: 1.25 } }
        }}
        withFormControl
        outerSx={{ gridColumn: 'span 2' }}
      />

      {isMidotUser && (
        <>
          <Field
            component={TextInput}
            name="legacyId"
            label={t('layouts.organizations.create.fields.oldPodiumAccountNumber')}
            innerProps={{ numbersOnly: true }}
            withFormControl
          />
          <Field
            component={TextInput}
            name="jiraId"
            label={t('layouts.organizations.create.fields.jiraAccountNumber')}
            innerProps={{ numbersOnly: true }}
            withFormControl
          />

          <Field
            component={TextInput}
            name="pipedriveId"
            label={t('layouts.organizations.create.fields.pipedriveAccountNumber')}
            innerProps={{ numbersOnly: true }}
            withFormControl
          />
        </>
      )}
    </Stack>
  );
};

export default SubOrgMoreInfoTab;
